import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const enrollmentsRoute: RouteConfig<'with-page'> = {
    name: 'Enrollments',
    path: '/training/enrollments',
    page: lazy(() => import('.')),
    flags: ['member-route'],
    context: 'member'
}